import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-cream-100" data-id="element-123">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-124">
        <div className="text-center" data-id="element-125">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-brand-pink-600 text-white rounded-full mb-8 shadow-xl" data-id="element-126">
            <div className="text-center" data-id="element-127">
              <ShieldCheckIcon className="w-12 h-12 mx-auto mb-2" data-id="element-128" />
              <p className="font-bold text-sm" data-id="element-129">GARANTÍA</p>
              <p className="font-bold text-2xl" data-id="element-130">7 DÍAS</p>
            </div>
          </div>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-6" data-id="element-131">
            ✅ GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl max-w-2xl mx-auto" data-id="element-132">
            <p className="text-lg md:text-xl text-gray-800 mb-4" data-id="element-133">
              Probá el programa COMPLETO.
            </p>
            <p className="text-lg md:text-xl text-gray-800 mb-4" data-id="element-134">
              Y si sentís que no es para vos, simplemente escribinos dentro de
              los primeros 7 días y te devolvemos el 100% de tu dinero.
            </p>
            <div className="space-y-2 text-lg font-semibold text-gray-900" data-id="element-135">
              <p data-id="element-136">Sin riesgo.</p>
              <p data-id="element-137">Sin preguntas incómodas.</p>
              <p data-id="element-138">Sin vueltas.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}